<template>
    <div v-if="hasCustomFields" class="grid-item grid-item-full">
        <div class="grid-content">
            <div
                :class="styles"
                v-for="(field, index) in fields"
                :key="field.name">
                <v-custom-field
                    :entry="field.definition"
                    v-model="field.value"
                    @input="triggerUpdate"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import vCustomField from './v-custom-field';

    export default {
        name: 'v-custom-fields-manager',
        components: {
            vCustomField,
        },
        props: {
            resourceType: {
                type: String,
                required: true,
            },
            value: {
                type: Object,
            },
            fluid: {
                type: Boolean,
                default: false,
            },
            preloadCustomFields: Array,
        },
        computed: {
            styles() {
                const style = {};
                if (this.fluid) {
                    style['grid-item grid-item-full'] = true;
                } else {
                    style['grid-item grid-item-half grid-item-break-half'] = true;
                }
                return style;
            },
            managerId() {
                return `custom-fields-${this.resourceType}`;
            },
            hasCustomFields() {
                return this.fields.length > 0;
            },
            fields() {
                return this.customFields.map(item => ({
                    value: this.value
                        ? this.value[item.fields.name]
                        : null,
                    definition: item.fields,
                }));
            },
        },
        data() {
            return {
                customFields: [],
            };
        },
        methods: {
            async fetchData() {
                this.$startLoading(this.managerId);
                try {
                    const response = await this.$api(({customFields}) => customFields.getAll({resource: this.resourceType}));
                    this.customFields = response.items;
                } catch (error) {
                    // TODO
                } finally {
                    this.$stopLoading(this.managerId);
                }
            },
            triggerUpdate() {
                const payload = {};
                this.fields.forEach((field) => {
                    if (field.value !== null) {
                        payload[field.definition.name] = field.value;
                    }
                });
                this.$emit('input', payload);
            },
        },
        created() {
            if (this.preloadCustomFields) {
                this.customFields = this.preloadCustomFields;
            } else {
                this.fetchData();
            }
        },
    };
</script>
